import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`appletProduct/findList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`appletProduct/saveData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`appletProduct/delData`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`appletProduct/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findAllData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`appletProduct/findAllData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
